{
  "version": 1,
  "asset_id": "c6d677a9-afc2-47c7-b714-5d4177fd50cf",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/c6d677a9-afc2-47c7-b714-5d4177fd50cf/techint.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/c6d677a9-afc2-47c7-b714-5d4177fd50cf/techint.png",
  "original_filename": "techint.png",
  "size": 24911,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:11Z"
}
